import { ResponsiveLine } from "@nivo/line";
import React from "react";
import { colors as appColors } from "../../styles/colors";
import { Box, Skeleton, Typography } from "@mui/material";
import { NoData } from "../NoData";

const HEIGHT = "300px";

export const PerformanceChart = ({
	data,
	offerNames,
	name,
	axisLeftTickValues,
	colors,
	containerStyle,
	loading,
}) => {
	if (!data) {
		return (
			<Box
				sx={{
					py: "20px",
					px: "50px",
					backgroundColor: "white.main",
					borderRadius: "20px",
					border: "1px solid #EFF0F6",
					height: HEIGHT,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					...containerStyle,
				}}
			>
				<NoData />
			</Box>
		);
	}

	if (loading) {
		return (
			<Skeleton
				variant="rounded"
				animation="wave"
				height={HEIGHT}
				width={"100%"}
				sx={{ borderRadius: "20px", ...containerStyle }}
			/>
		);
	}

	const CustomPointLabels = ({ points, series }) =>
		points.map((point) => {
			if (point.serieId === "placeholders" || point.data.y === -100) {
				return null;
			}

			const serieIndex = series.findIndex((s) => s.id === point.serieId);

			const color = serieIndex >= 0 ? colors[serieIndex - 1] : "#f00"; // красным, если ошибка

			return (
				<text
					key={point.id}
					x={point.x}
					y={point.y - 10}
					textAnchor="middle"
					fill={color}
					fontSize="12px"
					fontWeight="500"
					fontFamily="Inter"
				>
					{Number(point.data.y).toLocaleString()}
				</text>
			);
		});

	return (
		<Box
			sx={{
				backgroundColor: appColors.white,
				borderRadius: "20px",
				border: "1px solid #EFF0F6",
				height: "300px",
				position: "relative",
				...containerStyle,
			}}
		>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					p: "20px 53px 12px 73px",
					position: "absolute",
					width: "100%",
				}}
			>
				<Typography
					sx={{
						fontFamily: "Inter",
						fontSize: "16px",
						lineHeight: "20px",
						color: "#2C2C2C",
						fontWeight: "500",
					}}
				>
					{name}
				</Typography>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					{offerNames.map((offerName, i) => (
						<Box
							key={`${offerName}-budget`}
							sx={{ display: "flex", alignItems: "center", mr: "20px" }}
						>
							<Box
								sx={{
									width: "10px",
									height: "10px",
									borderRadius: "50%",
									backgroundColor: colors[i],
									mr: "6px",
								}}
							/>
							<Typography
								sx={{ fontSize: "16px", lineHeight: "20px", color: colors[i] }}
							>
								{offerName}
							</Typography>
						</Box>
					))}
				</Box>
			</Box>
			<ResponsiveLine
				data={data}
				colors={["transparent", ...colors]}
				margin={{ top: 55, right: 100, bottom: 50, left: 100 }}
				axisTop={null}
				axisRight={null}
				axisLeft={{ tickValues: axisLeftTickValues }}
				pointSize={8}
				enablePointLabel={true}
				pointLabel={() => null}
				theme={{
					axis: {
						ticks: {
							line: {
								strokeWidth: 0,
							},
							text: {
								fontSize: "12px",
								fontFamily: "Inter",
								fill: "#000000",
							},
						},
					},
					grid: {
						line: {
							stroke: "#ECECEC",
							strokeWidth: 1,
						},
					},
				}}
				gridYValues={axisLeftTickValues}
				layers={[
					"grid",
					"markers",
					"axes",
					"areas",
					"lines",
					"points",
					"slices",
					"mesh",
					(props) => <CustomPointLabels {...props} />,
				]}
			/>
		</Box>
	);
};
